import { Component, Input } from '@angular/core';
import { InspectionPointType } from '../../../../viewmodels/idms/inspection-point-type';

@Component({
  selector: 'hb-drawing-preview-legend',
  templateUrl: './drawing-preview-legend.component.html',
  styleUrls: ['./drawing-preview-legend.component.scss'],
})
export class DrawingPreviewLegendComponent {
  @Input() inspectionPointTypes: InspectionPointType[] = [];
}
